import React, { useRef } from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';

import BeamlineAttributeForm from './BeamlineAttributeForm';
import styles from './BeamlineAttribute.module.css';
import { HW_STATE } from '../../constants';

function formatAttributeValue(value, format, precision) {
  if (value === null) {
    return '-';
  }

  if (Array.isArray(value)) {
    return value.join(' x ');
  }

  if (typeof value === 'number') {
    return format === 'expo'
      ? value.toExponential(precision)
      : value.toFixed(precision);
  }

  return String(value);
}

function BeamlineAttribute(props) {
  const { attribute, format, precision = 1, suffix, onSave, onCancel } = props;
  const { state, value = 0, step = 0.1, msg, readonly = false } = attribute;

  const isBusy = state === HW_STATE.BUSY;
  const isTupleValue = Array.isArray(value);

  const btnRef = useRef(null);

  const valStr = formatAttributeValue(value, format, precision);

  if (readonly) {
    return (
      <span className={styles.value}>
        {valStr}
        {suffix && ` ${suffix}`}
      </span>
    );
  }

  return (
    <OverlayTrigger
      rootClose
      trigger="click"
      placement="right"
      onToggle={(show) => {
        if (!show) {
          // Bring focus back on button when popover closes
          btnRef.current?.focus({ preventScroll: true });
        }
      }}
      overlay={
        <Popover
          id="beamline-attribute-popover"
          className="d-flex align-items-center p-2"
        >
          <BeamlineAttributeForm
            value={value}
            isBusy={isBusy}
            step={step}
            precision={precision}
            onSave={onSave}
            onCancel={onCancel}
          />
          {msg && <div className="mx-3">{msg}</div>}
        </Popover>
      }
    >
      <Button
        ref={btnRef}
        className={styles.valueBtn}
        variant="link"
        data-busy={isBusy || undefined}
        data-default-styles
      >
        {valStr}
        {suffix && ` ${suffix}`}
      </Button>
    </OverlayTrigger>
  );
}

export default BeamlineAttribute;
